import React from "react"
import Title from "./Title"
import Blog from "./Blog"
import { Link } from "gatsby"
import Aos from "aos";
import "aos/dist/aos.css";



export const Blogs = ({blogs, title, showLink}) => {

  React.useEffect(() => {
    Aos.init({ duration: 2000 });
  }, [])
  
  return (
    <section className='section'>
      <Title title={title} />
      <div className="section-center blogs-center">
        {blogs.map(blog => <Blog key={blog.id} {...blog}></Blog>)}
      </div>
      {showLink && <Link to='/blog' className='btn center-btn'>MORE BLOGS</Link>}
    </section>
  )
}
export default Blogs
